<template>
  <div>
    <h6>Choix <i class="fa fa-question-circle text-primary" id="tooltip-choix"></i> de l'envoi par courrier postal des décomptes au format assureur par SIRET souscripteur <i class="fa fa-question-circle text-primary" id="tooltip-siret"></i> :</h6>

      <b-tooltip target="tooltip-choix" triggers="hover">
        Par défaut, le choix initial est l'arrêt de l'envoi postal
      </b-tooltip>
      <b-tooltip target="tooltip-siret" triggers="hover">
        Déplier pour consulter la liste des sites assurés rattachés au SIRET souscripteur et pour qui le choix sera aussi appliqué
      </b-tooltip>

    <b-row class="mt-3">
      <b-col v-if="isLoading" sm="6">
        <loading-field></loading-field>
      </b-col>
      <b-col v-else sm="12" md="8" lg="8" xl="6">
        <b-row v-if="isEmpty(siret)">
          <b-col sm="12">
            Aucun SIRET souscripteur trouvé, voulez vous relancer la recherche ?
            <b-button
              variant="primary"
              class="float-right ml-2"
              @click="getPreferenceDematerialisation()">
              <i class="fa fa-search"></i>
              Rechercher
            </b-button>
          </b-col>
        </b-row>
        <b-row v-else v-for="element in siret" :key="element.siret">
          <b-col sm="12" class="p-0">
            <div class="body-card m-2 w-100">
              <b-card no-body>
                <div class="card-smallHeader">
                  <span style="color: #d9418b"><b>{{ formatSiret(element.siret) }}</b>
                    <span style="color:black;"> / </span>
                    <span style="color: #349ee2"><b>{{ element.raison_sociale }}</b></span>
                    <b-badge variant="primary" class="ml-2" pill>{{ element.sites.length }}</b-badge>
                  </span>
                  <div class="card-header-actions float-right" v-b-toggle="element.siret">
                    <i class="text-primary mr-1" style="cursor: pointer;">Voir le détail </i>
                    <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
                    <span class="when-closed">
                      <i class="icon-arrow-up"></i>
                    </span>
                  </div>
                  <b-form-checkbox
                    class="d-inline-block float-right checkbox-demat"
                    v-model="preferences[element.siret]"
                    name="check-button"
                    switch
                    :disabled="!canChangeDematPreference()">
                  </b-form-checkbox>
                </div>
                <b-collapse :id="element.siret" class="m-3">
                  <div><b>Sites assurés rattachés au souscripteur :</b></div>
                  <span v-for="siteAssu in element.sites" :key="siteAssu.siret_assure"> 
                    {{ formatSiret(siteAssu.siret_assure) }} <br>
                  </span>
                </b-collapse>
              </b-card>
            </div>
          </b-col>
        </b-row>
        <b-button v-if="!isEmpty(siret) && canChangeDematPreference()"
          class="float-right" style="background-color: #8FBC8F; color: #fff;"
          @click="savePreferenceDematerialisation()">
          <i class="fa fa-save"></i>
          Enregistrer
        </b-button>
      </b-col>
      <b-col sm="12" md="4" lg="4" xl="6" class="pl-4">
        <b-row>
          <b-col sm="12" class="pl-4">
            <h6>Légende :</h6>
            <b-form-checkbox class="checkbox-demat" v-model="exempleFalse" name="exemple-papier" switch disabled>Décompte papier</b-form-checkbox> 
            <b-form-checkbox class="d-inline-block checkbox-demat" v-model="exempleTrue" name="exemple-demat" switch disabled>Dématérialisation</b-form-checkbox>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { isEmpty } from "@/utils/fileHelper";
  import { formatSiret } from "@/utils/communHelper";
  import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper";
  import LoadingField from "@/components/LoadingField";

  export default {
    name: "Dematerialisation",
    components: {
      LoadingField
    },
    data() {
      return {
        isEmpty,
        formatSiret,
        isLoading: false,
        siret: [],
        allPreferences: {},
        preferences: {},
        exempleTrue: true,   // Vert (Dématérialisation)
        exempleFalse: false  // Rouge (Décompte papier)
      }
    },
    props: [
      'siren',
    ],
    created() {
      this.getPreferenceDematerialisation();
      this.$event.on('changeSirenPreferences', (data) => {
        this.items = data;
      });
    },
    methods: {
      getPreferenceDematerialisation() {
        let self = this;
        this.isLoading = true;
        this.$axios
          .get('/referentielClient/siren/getSiretSouscripteur/' + this.siren)
          .then(response => {
            this.isLoading = false;
            this.siret = response.data.sirets || [];
            this.allPreferences = response.data.preferences || {};
            
            let newPrefs = {};
            for (let data of this.siret) {
              if (this.allPreferences[data.siret] !== undefined && this.allPreferences[data.siret] !== null) {
                newPrefs[data.siret] = Boolean(this.allPreferences[data.siret]);
              } else {
                newPrefs[data.siret] = true;
              }
            }
            this.preferences = newPrefs;
          })
          .catch((error) => {
            console.log(error);
            self.isLoading = false;
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      canChangeDematPreference() {
        return hasRule(rules.CAN_MANAGE_PREFERENCE_DEMATERIALISATION);
      },
      savePreferenceDematerialisation() {
        let self = this;
        
        let dataPost = {
          siren: this.siren,
          preferences: this.preferences
        };

        this.$store.commit('IS_LOADING', true);
        this.$axios
          .post('/referentielClient/siren/set-preference-demat', dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.$swal({
              position: 'top',
              type: 'success',
              title: 'Succès !!',
              text: 'Les préférences de dématérialisation ont bien été enregistrées.',
              showConfirmButton: false,
              timer: 5000
            });
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 6000
            });
          });
      },
    }
  }
</script>

<style type="text/css">
/*  Dématérialisation -> VERT (#4dbd74) -> coché -> true */
.checkbox-demat .custom-control-input:checked ~ .custom-control-label::before, 
.checkbox-demat.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  color: #4dbd74;
  border-color: #4dbd74;
  background-color: #4dbd74;  
}

/*  Décompte papier -> ROUGE (#f86c6b) -> décoché -> false */
.checkbox-demat .custom-control-input ~ .custom-control-label::before {
  color: #f86c6b;
  border-color: #f86c6b;
  background-color: #f86c6b;
}

.checkbox-demat.custom-switch .custom-control-input ~ .custom-control-label::after {
  background-color: #FFFFFF;
}
</style>